import { SVGProps } from 'react';

export const RotateAnticlockwiseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="14" height="14" viewBox="0 0 155 157" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="7"
        y="-7"
        width="106"
        height="68"
        rx="19"
        transform="matrix(-1 0 0 1 120 88.2708)"
        stroke="currentColor"
        strokeWidth="14"
      />
      <path
        d="M148 114.271V86.7708C148 42.7708 131.5 28.2708 89 28.2708H52"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path
        d="M15.0727 21.9573C9.99609 25.0812 9.99609 32.4604 15.0727 35.5842L48.8075 56.3423C54.1376 59.6221 61 55.7873 61 49.5289V8.01263C61 1.75419 54.1376 -2.08063 48.8075 1.1992L15.0727 21.9573Z"
        fill="currentColor"
      />
    </svg>
  );
};
